import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

export default function FormFieldset({
    children,
    className,
    ...props
}) {
    const classes = classNames(className);
    return (
        <div {...props} className={classes}>
            {children}
        </div>
    );
}

FormFieldset.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
